import ElementContentProductReview from '@/components/sections/builder/elements/body/product-review/content';
import ElementSettingProductReview from '@/components/sections/builder/elements/body/product-review/setting';
import { ProductReviewElementDataType } from '@/components/sections/builder/elements/body/product-review/type';
import { StarFilledIcon } from '@radix-ui/react-icons';

const defaultData: ProductReviewElementDataType = {
  name: 'Product Review',
  contentAlign: 'left',
  headingLabel: 'Product Reviews',
  headingSize: 'small',
  textLabel: '',
  textStyle: 'body',
  size: 'medium',
  showFilter: true,
  showSorting: true,
  showAttachments: true,
  reviewsPerPage: 5,
  defaultSortBy: 'created-descending',
};

export const ElementPreviewIcon = StarFilledIcon;

const ProductReview = {
  type: 'product_review',
  group: 'body_product_detail',
  defaultData,
  Element: ElementContentProductReview,
  Setting: ElementSettingProductReview,
  PreviewIcon: ElementPreviewIcon,
  defaultChilds: [],
  childs: [],
  maxEntries: 1,
};

export default ProductReview;
